import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getHeaders } from "./getHeaders";

export const getRestaurantProducts = createAsyncThunk(
  "Ststistics/getRestaurantProducts",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/restaurant-products`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurantSales = createAsyncThunk(
  "Ststistics/getRestaurantSales",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/restaurant-sales`,
          {},
          {
            headers: getHeaders(true),
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getDriverStatistics = createAsyncThunk(
  "Ststistics/getDriverStatistics",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/get-driver-statistics`,
          {},
          {
            headers: getHeaders(true),
            params: data && data,
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRevenueByLocation = createAsyncThunk(
  "Ststistics/getRevenueByLocation",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/get-revenue-byLocation`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getRestaurantRatings = createAsyncThunk(
  "Ststistics/getRestaurantRatings",
  async (data, thunkAPI) => {
    const { rejectWithValue } = thunkAPI;
    try {
      const result = await axios
        .post(
          `${process.env.REACT_APP_BACKEND_API}api/admin/statistics/restaurant-ratings`,
          data,
          {
            headers: getHeaders(true),
          }
        )
        .then((res) => res.data);
      return result;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const StstisticsSlice = createSlice({
  name: "Ststistics",
  initialState: {
    isStstisticsLoading: false,
    error: null,
    ResturantProductsArr: null,
    ResturantSalesArr: null,
    DriverStatisticsArr: null,
    RevenueByLocationArray: null,
    RestaurantRatingsArray: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRestaurantProducts.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantProducts.fulfilled, (state, action) => {
        state.ResturantProductsArr = action.payload.data;
        state.isStstisticsLoading = false;
      })
      .addCase(getRestaurantProducts.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload; // يمكن إضافة هذا السطر لتخزين الخطأ
      })

      .addCase(getRestaurantSales.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantSales.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.ResturantSalesArr = action.payload.data;
      })
      .addCase(getRestaurantSales.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })

      .addCase(getDriverStatistics.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getDriverStatistics.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.DriverStatisticsArr = action.payload.data.drivers;
      })
      .addCase(getDriverStatistics.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })
      .addCase(getRevenueByLocation.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRevenueByLocation.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.RevenueByLocationArray = action.payload.data;
      })
      .addCase(getRevenueByLocation.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      })

      .addCase(getRestaurantRatings.pending, (state) => {
        state.isStstisticsLoading = true;
      })
      .addCase(getRestaurantRatings.fulfilled, (state, action) => {
        state.isStstisticsLoading = false;
        state.RestaurantRatingsArray = action.payload.data.restaurants;
      })
      .addCase(getRestaurantRatings.rejected, (state, action) => {
        state.isStstisticsLoading = false;
        state.error = action.payload;
      });
  },
});

export default StstisticsSlice.reducer;
